export const VERSION = '3.9.0';
export const GIT_HASH = '2db9d9a5e087fffe73729e57645a0292b5e699b3';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'gg';
